import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Rocket";
const Rocket = memo(themed(Icon));
export {
  Rocket
};
//# sourceMappingURL=rocket.js.map
